import React from "react";
import AppModal from "../../../Components/Models/app-modal";
import FinalSummaryAgentReport from "./FormSteps/FinalSummeryAgentReport";
import FinalSummaryUserPayIn from "./FormSteps/FinalSummaryUserPayIn";
import FinalSummaryUserPayOut from "./FormSteps/FinalSummaryUserPayOut";
import FinalSummaryOfficeExpense from "./FormSteps/FinalSummaryOfficeExpense";
import FinalSummaryOwnerCollection from "./FormSteps/FinalSummaryOwnerCollection";
import FinalSummaryCommissionSettlement from "./FormSteps/FinalSummaryCommissionSettlement";
import FinalSummaryBalanceAdjustment from "./FormSteps/FinalSummaryBalanceAdjustment";
import api from "../../../Services/Api/api";
import AppComponent from "../../../Components/AppComponent";

class TransactionDetails extends AppComponent {
  componentRef = React.createRef(null);

  state = { transaction: this.props.transaction };

  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      if (!this.props.transaction?._id) return;
      const { transactions } = await api.get("v1/office/transaction", {
        queryStr: JSON.stringify({
          where: { _id: this.props?.transaction?._id },
          populate: "relatedUser office headOffice",
          limit: 1,
        }),
      });
      console.log({ transactions });
      this.setState({ transaction: transactions?.[0] });
    } catch (e) {
      console.error("Error getting latest tr data", e.message);
    }
  }

  renderDetails() {
    const transaction = this.state.transaction || {};
    const { transactionType } = transaction;

    const detailsByType = {
      agent_report: FinalSummaryAgentReport,
      user_payin: FinalSummaryUserPayIn,
      user_payout: FinalSummaryUserPayOut,
      office_expense: FinalSummaryOfficeExpense,
      owner_collection: FinalSummaryOwnerCollection,
      commission_settlement: FinalSummaryCommissionSettlement,
      adjustment: FinalSummaryBalanceAdjustment,
    };

    const DetailsComponent = detailsByType[transactionType];

    if (!DetailsComponent) return null;

    return (
      <DetailsComponent
        mode="details"
        data={transaction}
        handleClose={this.props.handleClose}
        handleEdit={
          transaction.createdBy === this.props.user._id
            ? this.props.handleEdit
            : null
        }
        handleDelete={
          transaction.createdBy === this.props.user._id
            ? this.props.handleDelete
            : null
        }
        handleApprove={
          transaction.headOffice?._id === this.props.user._id &&
          transaction.status === "pending"
            ? this.props.handleApprove
            : null
        }
        componentRef={this.componentRef}
      />
    );
  }

  render() {
    return (
      <AppModal
        visible={this.props.visible}
        handleClose={this.props.handleClose}
        title={"Transaction Details"}
        showFooter={false}
        // modalProps={{ centered: true }}
      >
        {this.renderDetails()}
      </AppModal>
    );
  }
}

export default TransactionDetails;
